import clarity from '@microsoft/clarity';

export default defineNuxtPlugin(() => {
    if (process.client) {
        try {
            clarity.init('q0cr22uo2t'); // Ganti dengan Site ID Anda
            console.log('Clarity initialized');
        } catch (error) {
            console.error('Clarity initialization error:', error);
            // console.error(error.stack); // Cek lebih rinci
        }
    }
});
